import React, { useEffect, useState } from "react";
import ReactDragList from "react-drag-list";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Grid, IconButton, Menu, MenuItem } from "@material-ui/core";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import { meetingService } from "../../services/meeting/meeting.service";
import { Label } from "reactstrap";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import DeleteIcon from "@material-ui/icons/Delete";

const DEFAULT_OPTION = {
  id: null,
  sortOrder: 0,
  layoutId: -1,
  label: "Option",
  url: "",
};

export const MenuEditor = (props) => {
  const { menu, onChange, eventId } = props;

  const [isSavable, setIsSavable] = useState(false);
  const [open, setOpen] = useState(false);
  const [layouts, setLayouts] = useState([]);
  const [modifiedMenu, setModifiedMenu] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showConfirmDialog, toggleConfirmDialog] = useState(false);

  useEffect(() => {
    fetchLayouts();
    setModifiedMenu(menu);
  }, []);

  const addOption = () => {
    const newModifiedMenu = Array.from(modifiedMenu);
    const newOption = Object.assign({}, DEFAULT_OPTION);

    newOption.id = btoa(+new Date());
    newOption.sortOrder = modifiedMenu.length + 1;

    newModifiedMenu.push(newOption);
    setModifiedMenu(newModifiedMenu);
    setIsSavable(true);
  };

  const fetchLayouts = () => {
    meetingService.getLayouts(eventId).then((res) => {
      setLayouts(res);
    });
  };

  const deleteOption = (id) => {
    const newModifiedMenu = Array.from(modifiedMenu);
    const index = newModifiedMenu.indexOf(modifiedMenu.find((m) => m.id == id));
    if (index > -1) newModifiedMenu[index].deleted = true;
    setModifiedMenu(newModifiedMenu);
    setIsSavable(true);
  };

  const editOption = (option) => {
    const newModifiedMenu = Array.from(modifiedMenu);
    const index = newModifiedMenu.indexOf(modifiedMenu.find((m) => m.id == option.id));
    if (index > -1) newModifiedMenu[index] = option;
    setModifiedMenu(newModifiedMenu);
    setIsSavable(true);
  };

  const handleOrderChange = (event, dataSource) => {
    const sortedOptions = dataSource.map((ds, i) => {
      let el = Object.assign({}, ds);
      el.sortOrder = i;
      return el;
    });
    setModifiedMenu(sortedOptions);
    setIsSavable(true);
  };

  const save = () => {
    onChange(modifiedMenu.filter((m) => m.deleted != true));
    handleClose(true);
    if (showConfirmDialog == true) toggleConfirmDialog(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (forced = false) => {
    if (isSavable && !forced) {
      return toggleConfirmDialog(true);
    }
    setOpen(false);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {showConfirmDialog ? <ConfirmDialog save={save} toggle={() => handleClose(true)} toggleConfirmDialog={() => toggleConfirmDialog(!showConfirmDialog)} /> : null}
      <Grid container>
        <Grid item>
          <Label className="primary-text">
            <SystemLabel name="MenuOptions" />
          </Label>
        </Grid>
        <Grid item style={{ justifyContent: "flex-end", display: "flex", width: "100%" }}>
          <Button style={{ marginTop: "5px", border: 0, marginBottom: "5px", color: "rgb(255, 255, 255)", backgroundColor: "rgb(63, 65, 76)", width: "100%" }} variant="outlined" color="primary" onClick={handleClickOpen}>
            <SystemLabel name="EditOption" />
          </Button>
        </Grid>
      </Grid>

      <Dialog
        PaperProps={{
          style: {
            width: "600px",
            minHeight: "400px",
          },
        }}
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <SystemLabel name="MenuOptionEditing" />
        </DialogTitle>

        <DialogContent>
          <div className="add-placeholder" onClick={addOption}>
            <SystemLabel name="AddOption" />
            <PlaylistAddIcon style={{ marginLeft: 10 }} />
          </div>
          <ReactDragList
            animation={10}
            dataSource={modifiedMenu}
            rowKey={"id"}
            className="simple-drag"
            rowClassName="simple-drag-row-menu"
            dragClass="agenda-drag"
            handles={true}
            onUpdate={(event, dataSource) => handleOrderChange(event, dataSource)}
            row={(a, index) => {
              return (
                <div style={{ display: "flex", width: "100%" }}>
                  <div style={{ flexBasis: "50%", margin: "0px 5px" }}>
                    <div style={{ marginBottom: "0.5rem" }}>
                      <SystemLabel name="MenuItemName" />
                    </div>
                    <input
                      className="silent-input"
                      value={a.label}
                      onChange={(e) => {
                        editOption({ ...a, label: e.target.value });
                      }}
                    />
                  </div>
                  <div style={{ flexBasis: "50%", margin: "0px 5px" }}>
                    <div style={{ marginBottom: "0.5rem" }}>
                      <SystemLabel name="Layout" />
                    </div>
                    <div style={{ display: "flex" }}>
                      <div aria-controls="layout-menu" onClick={handleMenuClick} style={{ display: "flex", justifyContent: "space-between" }} className="silent-input">
                        {layouts.find((l) => l.meetingLayoutId == a.layoutId)?.name ?? "-"}
                        <ArrowDropDownIcon />
                      </div>
                    </div>
                  </div>

                  <Menu id="layout-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
                    {layouts.map((l) => {
                      return (
                        <MenuItem
                          key={l.meetingLayoutId}
                          onClick={() => {
                            editOption({ ...a, layoutId: l.meetingLayoutId });
                            handleMenuClose();
                          }}
                        >
                          {l.name}
                        </MenuItem>
                      );
                    })}
                  </Menu>
                  <IconButton onClick={() => deleteOption(a.id)}>{a.deleted ? <RestoreFromTrashIcon /> : <DeleteIcon />}</IconButton>
                </div>
              );
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            <SystemLabel name="Cancel" />
          </Button>
          <Button disabled={!isSavable} onClick={save} color="primary" variant="contained" autoFocus>
            <SystemLabel name="Save" />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const ConfirmDialog = ({ save, toggle, toggleConfirmDialog }) => {
  return (
    <div>
      <Dialog open={true} onClose={() => null} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          <SystemLabel name="UnsavedChanges" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <SystemLabel name="UnsavedChangesDetails" />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={toggleConfirmDialog} color="primary">
            <SystemLabel name="Cancel" />
          </Button>
          <Button onClick={toggle} color="primary">
            <SystemLabel name="Leave" />
          </Button>
          <Button onClick={save} color="primary" variant="contained" autoFocus>
            <SystemLabel name="Save" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
